import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from "@angular/router";

// External Modules
import { catchError, EMPTY, map, Observable, of } from "rxjs";
import { SsrCookieService } from "ngx-cookie-service-ssr";

// Services
import { CampaignStorageService } from "src/app/api/services/storage/campaign-storage.service";
import { CampaignService } from "src/app/api/services/campaign/campaign.service";

// Constants
import { API, API_PREVIEW } from "src/app/constants/api";
import { ErrorType } from "src/app/constants/enums/campaign/error/error-type.enum";
import { ApiModule } from "src/app/constants/enums/api-module.enum";


@Injectable({ providedIn: 'root' })
export class IgResultResolver implements Resolve<any> {
  constructor(
    private campaignService: CampaignService,
    private storage: CampaignStorageService,
    private router: Router,
    private cookieService: SsrCookieService
  ) { }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<any> | Promise<any> {
    if (this.storage.getResult() && this.storage.getCampaign()) { return of(null); }

    let previewMode = state.url.indexOf('c/prv') > -1;

    let api = previewMode ? API_PREVIEW : API;
    // Get all query params from route
    const queryParams = route.queryParams;

    // when get query params set in local
    if (queryParams) {
      localStorage.setItem('paramss', JSON.stringify(queryParams));
    }

    let payload = {
      cmp_id: route.paramMap.get('cmp_id'),
      player_cookie: this.cookieService.get(route.paramMap.get('cmp_id')) || route.paramMap.get('url_code'),
      paramss: queryParams || {}
    };

    return this.campaignService.campaignCommon({ module: ApiModule.INTERACTIVE_GAME, url: api.CampaignResult }, payload, payload).pipe(map((res: any) => {
      // set cookie
      this.cookieService.set(payload.cmp_id, res?.data?.result?.rs_cookie_no, { path: '/' });
      this.storage.setCampaignData(res?.data?.campaign, res?.data?.editor, res?.data?.validation_setting, res?.data?.advance_setting,
        res?.data?.result, res?.data?.access, res?.data?.reward);
      return res;
    }), catchError(err => {
      // navigate to error page
      if (err?.error?.data?.campaign) {
        let errorType = ErrorType[err.error.message] || ErrorType.SERVER_ERROR;
        this.storage.setErrorCampaign({ errorType, campaign: err?.error?.data?.campaign });
        return of(true);
      }
      this.router.navigate(['error', ErrorType[err.error.message] || ErrorType.SERVER_ERROR])
      return of(true);
    }));
  }
}